import { Navigate, useLocation } from "react-router-dom";

import useAuth from "../../context/authContext";

import { Dev } from "../../util/consoleUtil";
import { UtilComponents } from "../../util/utilComponents";

import { ContainerNodeProps } from "../../../types/common";

export default function RequireStaff({ children }: ContainerNodeProps) {
  const { currentUserState } = useAuth();

  const location = useLocation();

  if (!UtilComponents.isStaff(currentUserState)) {
    console.log(...new Dev("This route require staff permission").Error());

    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children as JSX.Element;
}
